import {createSlice} from "@reduxjs/toolkit";

export const initialState = {
    currentPage: 1,
    pageSize: 5,
};

export const  groupEpListTableControllerSlice = createSlice({
    name: 'groupEpListTableControllerSlice',
    initialState,
    reducers: {
        changeCurrentPage(state, action) {
            state.currentPage = action.payload.page;
            state.pageSize = action.payload.pageSize;
        },
    },
});

export const {changeCurrentPage} = groupEpListTableControllerSlice.actions;

export default groupEpListTableControllerSlice.reducer;